export default {"src":"/_next/static/media/linkedin.cbc25b6f.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};